"use client"
import React from 'react'
import { useState } from "react"
import { createPortal } from 'react-dom'
import HlsVideo from '@/app/components/HlsVideo'
import WatermarkBadge from '@/app/components/WatermarkBadge'
import { countDown } from '@/app/utils/CountDown'
import type { MmDict } from '@/lib/i18n/dicts/mm'

const TryGameTime = 180

/**
 * 移动版试玩动作组件：
 * 逻辑与 GameDetail2Actions 一致（3 分钟试玩倒计时 / mp4 视频 / 横竖版切换 / 926 半屏直播模式 / 玩法视频弹窗），
 * 尺寸适配手机屏幕；弹窗通过 createPortal 挂到 document.body，保证相对屏幕居中
 * text：双语按钮/弹窗文案，由服务端详情页按 locale 传入
 */
export default function MMGameDetailActions({ gamehref, gamescreen, gamevideo = "", gameid = 0, text }: {
    gamehref: string
    gamescreen: string
    gamevideo?: string
    gameid?: number
    text: MmDict['detail']['actions']
}) {
    const [isVideoPoppedUp, setVideoPopUp] = useState(false)
    const [countDownTime, setCountDownTime] = useState(TryGameTime || 0)
    const [currentPhoneHS, setCurrentPhoneHS] = useState(gamescreen)
    const [isGameVideoPopedUp, setGameVideoPopedUp] = useState(false)

    let VarcountDownTime = TryGameTime;

    function changetime(_time: number) {
        VarcountDownTime = VarcountDownTime - 1;
        setCountDownTime(VarcountDownTime);
    }

    function fromatCountDownTime(time: number) {
        let returnvalue = ""
        returnvalue = returnvalue + Math.floor(time / 60) + ":" + (time % 60 > 9 ? time % 60 : "0" + time % 60)
        return returnvalue
    }

    function handleLijiShiwan() {
        if (countDownTime == TryGameTime || countDownTime < 1) {
            setVideoPopUp(true)
            if (!gamehref.endsWith("mp4"))
                countDown(TryGameTime, changetime, countdownEnd);
        }
        else {
            setVideoPopUp(true)
        }
    }

    function handlePlayGameVideo() {
        setGameVideoPopedUp(true)
    }

    function handleCloseGameVideo() {
        setGameVideoPopedUp(false)
    }

    function countdownEnd() {
        var eletrygameCover = document.getElementById('trygameCover')
        if (eletrygameCover != null)
            document.getElementById('trygameCover')!.style.display = "";
        gamehref.endsWith("mp4") ? document.getElementById('popupdivmp4')!.style.display = "none" : document.getElementById('popupdivgame')!.style.display = "none";
    }

    function handleJiXuShiwan() {
        setCountDownTime(0)
        document.getElementById('trygameCover')!.style.display = "none";
        gamehref.endsWith("mp4") ? document.getElementById('popupdivmp4')!.style.display = "" : document.getElementById('popupdivgame')!.style.display = "";
    }

    function handleClose() {
        setCountDownTime(0);
        setVideoPopUp(false)
    }

    function handleChangePhone() {
        setCurrentPhoneHS(currentPhoneHS == '竖版' || currentPhoneHS === '横竖版' ? "横版" : "竖版")
    }

    // 右上角关闭按钮（带倒计时）
    const closeBtn = (onClick: () => void, showTime = false) => (
        <button
            className="absolute -top-2 -right-2 z-10 w-11 h-11 rounded-full bg-slate-800 text-white ring-1 ring-white/15 text-[10px] font-bold flex flex-col items-center justify-center"
            onClick={onClick}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
            </svg>
            {showTime && countDownTime != 0 ? fromatCountDownTime(countDownTime || 0) : ""}
        </button>
    )

    // 所有弹窗集中，通过 portal 挂到 body
    const modals = (
        <>
            {/* 试玩 / 视频弹窗 */}
            {
                isVideoPoppedUp ? (
                    <>
                        {gamehref.endsWith("mp4") ? (
                            <div className="fixed inset-0 w-full h-full flex items-center justify-center z-50" id='popupdivmp4'>
                                <div className="absolute inset-0 w-full h-full bg-black/70 backdrop-blur-sm" onClick={handleClose}></div>
                                <div className="relative" id='trygame' style={{ display: '' }}>
                                    <div className="p-1.5 bg-slate-900 ring-1 ring-white/10 rounded-xl relative">
                                        <video className="rounded-lg w-[84vw] h-[68vh] object-contain bg-black" controls autoPlay={true} loop={true} controlsList="nodownload" onContextMenu={(e) => e.preventDefault()}>
                                            <source src={gamehref} type="video/mp4" />
                                        </video>
                                        <WatermarkBadge />
                                    </div>
                                    {closeBtn(handleClose)}
                                </div>
                            </div>
                        )
                            :
                            gameid === 926 ? (
                                // 926 点球大战为半屏游戏：iframe 框内上半部分为主播直播画面，下半部分显示游戏内容
                                <div className="fixed inset-0 w-full h-full flex items-center justify-center z-50" id='popupdivgame'>
                                    <div className="absolute inset-0 w-full h-full bg-black/70 backdrop-blur-sm" onClick={handleClose}></div>
                                    <div className="relative" id='trygame' style={{ display: '' }}>
                                        <div className="p-1.5 bg-slate-900 ring-1 ring-white/10 rounded-xl">
                                            <div className="relative w-[84vw] h-[68vh] rounded-lg overflow-hidden">
                                                <img
                                                    src="/img/gamedetail/926/live-bg.png"
                                                    alt="直播画面"
                                                    className="absolute top-0 left-0 w-full h-1/2 object-cover"
                                                />
                                                <iframe
                                                    id="iframe_gameRef"
                                                    className="absolute bottom-0 left-0 w-full h-1/2 bg-white"
                                                    src={gamehref}>
                                                </iframe>
                                            </div>
                                        </div>
                                        {closeBtn(handleClose, true)}
                                    </div>
                                </div>
                            )
                            :
                            (
                                <div className="fixed inset-0 w-full h-full flex items-center justify-center z-50" id='popupdivgame'>
                                    <div className="absolute inset-0 w-full h-full bg-black/70 backdrop-blur-sm" onClick={handleClose}></div>
                                    <div className="relative" id='trygame' style={{ display: '' }}>
                                        <div className="p-1.5 bg-slate-900 ring-1 ring-white/10 rounded-xl">
                                            <iframe
                                                id="iframe_gameRef"
                                                className={`block rounded-lg ${currentPhoneHS === '竖版' || currentPhoneHS === '横竖版' ? "w-[84vw] h-[68vh]" : "w-[92vw] h-[54vh]"}`}
                                                src={gamehref}>
                                            </iframe>
                                        </div>
                                        {closeBtn(handleClose, true)}
                                        {gamescreen === '横竖版' ? (
                                            <button
                                                className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-11 h-11 rounded-full bg-slate-800 text-white ring-1 ring-white/15 flex items-center justify-center"
                                                onClick={handleChangePhone}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={`w-5 h-5 ${currentPhoneHS === '竖版' || currentPhoneHS === '横竖版' ? "rotate-90" : ""}`}>
                                                    <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 1.5H8.25A2.25 2.25 0 0 0 6 3.75v16.5a2.25 2.25 0 0 0 2.25 2.25h7.5a2.25 2.25 0 0 0 2.25-2.25v-16.5a2.25 2.25 0 0 0-2.25-2.25H13.5m-3 0V3h3V1.5m-3 0h3m-3 18.75h3" />
                                                </svg>
                                            </button>
                                        ) : ""}
                                    </div>
                                </div>
                            )}
                    </>
                ) : ""
            }

            {/* 试玩倒计时结束遮罩 */}
            {
                isVideoPoppedUp ? <div id='trygameCover' className="fixed inset-0 w-full h-full flex items-center justify-center z-[60] bg-black/40" style={{ display: 'none' }}>
                    <div className="absolute inset-0 w-full h-full bg-black/60 backdrop-blur-sm" onClick={handleClose}></div>
                    <div className="relative mx-6 w-full max-w-sm rounded-3xl bg-slate-900 ring-1 ring-indigo-400/30 p-8 text-center shadow-2xl shadow-indigo-600/20">
                        <h2 className="text-xl font-bold leading-tight text-white">{text.coverTitle}</h2>
                        <p className="mt-3 text-lg leading-8 text-indigo-300">188 0038 2271</p>
                        <div className="mt-5 flex flex-col gap-3">
                            <a href="/mm/contact" className="flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-indigo-500 to-fuchsia-500 px-5 py-2.5 text-sm font-medium text-white">
                                <span>{text.contact}</span>
                            </a>
                            <button className="flex items-center justify-center gap-2 rounded-full border border-white/50 px-5 py-2.5 text-sm font-medium text-white"
                                onClick={handleJiXuShiwan}
                            >
                                <span>{text.resume}</span>
                            </button>
                        </div>
                    </div>
                </div>
                    : ""}

            {/* 玩法视频弹窗 */}
            {
                isGameVideoPopedUp ? (
                    <div className="fixed inset-0 w-full h-full flex items-center justify-center z-50" id='popupgamevideo'>
                        <div className="absolute inset-0 w-full h-full bg-black/70 backdrop-blur-sm" onClick={handleCloseGameVideo}></div>
                        <div className="relative" id='playgamevideo' style={{ display: '' }}>
                            <div className="p-1.5 bg-slate-900 ring-1 ring-white/10 rounded-xl relative">
                                <HlsVideo className="rounded-lg w-[88vw] max-h-[70vh] bg-black" controls autoPlay={true} loop={true} src={gamevideo} />
                                <WatermarkBadge />
                            </div>
                            {closeBtn(handleCloseGameVideo)}
                        </div>
                    </div>
                ) : ""
            }
        </>
    )

    return (
        <>
            {/* 动作按钮 */}
            <div className="mt-5 flex gap-3">
                <button
                    onClick={handleLijiShiwan}
                    className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-indigo-500 to-fuchsia-500 px-5 py-3 text-sm font-bold text-white shadow-lg shadow-indigo-600/30 active:scale-95 transition-transform"
                >
                    {gamehref.endsWith("mp4") ? (
                        <>
                            <span>{text.playVideo}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
                            </svg>
                        </>
                    ) : (
                        <>
                            <span className="whitespace-nowrap">{text.play}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path>
                            </svg>
                        </>
                    )}
                </button>

                {gamevideo == "" ? "" : (
                    <button
                        onClick={handlePlayGameVideo}
                        className="flex-1 inline-flex items-center justify-center gap-2 rounded-full ring-1 ring-white/20 px-5 py-3 text-sm font-medium text-slate-200 active:scale-95 transition-transform"
                    >
                        <span className="whitespace-nowrap">{text.gameVideo}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
                        </svg>
                    </button>
                )}
            </div>

            {/* 弹窗挂到 body，避免父级动画 transform 影响 fixed 居中定位 */}
            {typeof document !== 'undefined' ? createPortal(modals, document.body) : null}
        </>
    )
}
